import React, { Component, Fragment } from 'react'
import classnames from 'classnames'

export interface InputFieldProps {
  type?: React.HTMLInputTypeAttribute // 'text' | 'email' | 'tel' | etc.
  name: string
  id: string
  placeholder?: string
  label: string
  reference?:
    | React.RefObject<HTMLInputElement | null>
    | ((instance: HTMLInputElement | null) => void)
    | null
  error?: boolean
  message?: string
  hideStyle?: string // CSS utility class used to hide the error list
}

class InputField extends Component<InputFieldProps> {
  static defaultProps: Partial<InputFieldProps> = {
    type: 'text',
    error: false,
    message: '',
    hideStyle: 'u-invisible',
  }

  // eslint-disable-next-line no-useless-constructor
  constructor(props: InputFieldProps) {
    super(props)
  }

  render() {
    const { name, type, id, placeholder, reference, error, label, message, hideStyle } = this.props

    const currentHideStyle = hideStyle || 'u-invisible'

    return (
      <Fragment>
        <label className='Input-label u-marginBottom4' htmlFor={id}>
          {label}
        </label>

        <div className='Input-group'>
          <input
            className={classnames('Input', {
              'Input--error': error === true,
            })}
            data-qa={`Input-${id}`}
            name={name}
            id={id}
            placeholder={placeholder}
            type={type}
            ref={reference as any} // supports both RefObject and callback refs
          />
        </div>

        <ul
          className={`Input-errorList u-paddingTop4 u-marginBottom8 u-marginLeft4 u-marginTop0 ${
            error ? '' : currentHideStyle
          }`}
        >
          <li className='Form-help Form-help--error' data-qa={`InputError-${id}`}>
            <span
              aria-hidden='true'
              className='Input-icon Icon'
              dangerouslySetInnerHTML={{ __html: '&#xE002' }}
            />
            <span>{message}</span>
          </li>
        </ul>
      </Fragment>
    )
  }
}
export { InputField }
export default InputField
